import { action, computed, makeObservable } from 'mobx';

import { SetValueOptions } from '@/stores/interfaces/IFormField';
import { IFormStore } from '@/stores/interfaces/IFormStore';
import { OptionEntity } from '@/types/OptionEntity';

import { BaseFieldSelectStore } from './BaseFieldSelectStore';
import { FieldSelectStoreOptions } from './types';

export class FieldSelectStore<V extends OptionEntity = OptionEntity>
  extends BaseFieldSelectStore<V>
  implements IFormStore<V['key'] | null, V['key'] | null>
{
  constructor(options: FieldSelectStoreOptions<V>) {
    super(options);

    makeObservable(this, {
      setValueByKey: action.bound,
      serverFormat: computed.struct,
      setFromServerFormat: action.bound,
      setFromQueryFormat: action.bound,
    });
  }

  setValueByKey(key: V['key'], options?: SetValueOptions) {
    this.setValue(
      this.options.filter((i) => i.key === key),
      options,
    );
  }

  /**
   * Заполняет значение поле из серверных данных
   * @param from серверные данные
   */
  setFromServerFormat(): void {
    // TODO
  }

  setFromQueryFormat(from: string): void {
    this.setValue([{ key: from.toString(), value: '' } as V], { noTouch: true });
    this.syncValueByKeys([from]);
  }

  //** Значение поле в серверном формате **/
  get serverFormat(): V['key'] | null {
    return this.value[0]?.key || null;
  }
}
